import React from 'react';
import { Heart, Users, ChefHat, ShoppingBag, Clock, Star, MapPin } from 'lucide-react';
import '../About Us/AboutUs.css';

const AboutUs: React.FC = () => {
  return (
    <div className="about-us-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-content1">
          <div className="hero-text">
            <h1 className="hero-title1">About Us</h1>
            <div className="hero-story">
              <p className="intro-text">
                Hi, we're the Gobal Family. HomeCookt connects the world.
              </p>
              <p className="main-idea">
                Good food tastes better when it's made nearby — by someone you trust.
              </p>
            </div>
          </div>
          <div className="hero-visual">
            <div className="family-card">
              <Heart className="heart-icon" size={32} />
              <span>Made with love by the Gobal Family</span>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="mission-content">
          <div className="mission-text">
            <h2>Our Mission</h2>
            <p className="mission-description">
              HomeCookt is a community-powered platform where people buy and sell fresh, 
              home-cooked meals within their neighbourhoods.
            </p>
            
            <div className="mission-points">
              <div className="mission-point">
                <ChefHat className="point-icon" />
                <span>Cooks get to earn by doing what they love.</span>
              </div>
              <div className="mission-point">
                <Users className="point-icon" />
                <span>Buyers get real food made by real people.</span>
              </div>
              <div className="mission-point">
                <Heart className="point-icon" />
                <span>Everyone wins.</span>
              </div>
            </div>

            <p className="mission-belief">
              We believe in making food personal, fair, and easy — with no pressure, 
              no phone calls, and no fuss.
            </p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="how-it-works-content">
          <h2 className="section-title">How It Works</h2>
          
          <div className="how-it-works-grid">
            {/* For Buyers */}
            <div className="user-type-card buyers-card">
              <div className="card-header">
                <ShoppingBag className="card-icon" size={40} />
                <h3>For Buyers</h3>
              </div>
              
              <div className="steps-list">
                <div className="step1">
                  <span className="step-number1">1</span>
                  <span className="step-text">Browse home-cooked meals near you</span>
                </div>
                <div className="step1">
                  <span className="step-number1">2</span>
                  <span className="step-text">Tap "Order" — no calls, no hassle</span>
                </div>
                <div className="step1">
                  <span className="step-number1">3</span>
                  <span className="step-text">Collect or get it delivered locally</span>
                </div>
              </div>

              <div className="features-list">
                <div className="feature">
                  <Star className="feature-icon1" size={16} />
                  <span>Save your favourite cooks</span>
                </div>
                <div className="feature">
                  <Clock className="feature-icon1" size={16} />
                  <span>Reorder with one tap</span>
                </div>
                <div className="feature">
                  <Heart className="feature-icon1" size={16} />
                  <span>Trusted, real food from real kitchens</span>
                </div>
              </div>
            </div>

            {/* For Cooks */}
            <div className="user-type-card cooks-card">
              <div className="card-header">
                <ChefHat className="card-icon" size={40} />
                <h3>For Cooks</h3>
              </div>
              
              <div className="steps-list">
                <div className="step1">
                  <span className="step-number1">1</span>
                  <span className="step-text">Upload a meal you've made</span>
                </div>
                <div className="step1">
                  <span className="step-number1">2</span>
                  <span className="step-text">Get orders from neighbours</span>
                </div>
                <div className="step1">
                  <span className="step-number1">3</span>
                  <span className="step-text">Share and earn — your way</span>
                </div>
              </div>

              <div className="features-list">
                <div className="feature">
                  <MapPin className="feature-icon1" size={16} />
                  <span>No menus to design</span>
                </div>
                <div className="feature">
                  <Clock className="feature-icon1" size={16} />
                  <span>Cook anytime you want</span>
                </div>
                <div className="feature">
                  <Heart className="feature-icon1" size={16} />
                  <span>Get paid for your passion</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="values-content">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <Heart className="value-icon" size={32} />
              <h3>Personal</h3>
              <p>Every meal tells a story. We connect you with the people behind the food.</p>
            </div>
            <div className="value-card">
              <Users className="value-icon" size={32} />
              <h3>Fair</h3>
              <p>Transparent pricing and honest reviews. Everyone gets a fair deal.</p>
            </div>
            <div className="value-card">
              <Clock className="value-icon" size={32} />
              <h3>Easy</h3>
              <p>Simple ordering, no pressure, no fuss. Food should be enjoyable, not stressful.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;